import root from './_root';

/** Built-in value references. */
var Reflect = root.Reflect;

export default Reflect;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_Reflect.js
// module id = 298
// module chunks = 0